import { type AxiosError } from 'axios'
import { buildAxiosInstance } from '../utils/apiUtils'
import { proxyNewUser } from '../proxies/newUserProxy'
import { FormFieldNamesEnum } from '../../routes/app/settings/account/NewUserForm/formFieldNamesEnum'

interface Args {
  email: string
}

interface Response {
  data: any
  error: string | null
}

export async function executeDetermineIsEmailAvailable ({ email }: Args): Promise<void> {
  proxyNewUser.emailValidationCall.loading = true
  proxyNewUser.emailValidationCall.error = null
  const currentUserId = proxyNewUser.selectedUser?.id
  try {
    const response = await buildAxiosInstance().post<Response>('/api/users/validate_email', {
      email: email.toLowerCase(),
      userId: currentUserId
    })
    if (!response.data.error) {
      proxyNewUser.formErrors[FormFieldNamesEnum.Email] = null
      proxyNewUser.showEmailError = false
    } else {
      proxyNewUser.emailValidationCall.error = 'Email is already in use'
    }
  } catch (e) {
    if (e instanceof Error) {
      const bodyError = (e as AxiosError<Response>).response?.data?.error
      proxyNewUser.emailValidationCall.error = bodyError ?? e.message

      proxyNewUser.formErrors[FormFieldNamesEnum.Email] = 'Email is already in use'
      proxyNewUser.showEmailError = true
    }
  } finally {
    proxyNewUser.emailValidationCall.loading = false
  }
}
